import { mask, formatPhone, normalizePhone } from './masks.js'

export default mask(formatPhone, normalizePhone)
